import http from "@/utils/httpService";

export function ClientsTreeApi() {
  return http.Axios({
    url: "/web/clientsCompany/tree",
    method: "get"
  });
}

export function ClientsPageApi(data) {
  return http.Axios({
    url: "/web/clientsCompany/listSelfAndChilds",
    method: "get",
    params: data
  });
}

export function ClientsSelectByIdApi(id) {
  return http.Axios({
    url: "/web/clientsCompany/findById/" + id,
    method: "get"
  });
}

export function ClientsDeleteApi(id) {
  return http.Axios({
    url: "/web/clientsCompany/delCompany/" + id,
    method: "post"
  });
}

export function ClientsInsertApi(data) {
  return http.Axios({
    url: "/web/clientsCompany/save",
    method: "post",
    data: data
  });
}

export function ClientsUpdateApi(data) {
  return http.Axios({
    url: "/web/clientsCompany/updateCompany",
    method: "post",
    data: data
  });
}

export function ClientsUpdateStateApi(state, companyIdList) {
  return http.Axios({
    url: "/web/clientsCompany/used/" + state,
    method: "post",
    data: companyIdList
  });
}

export function treeByOrgIdApi() {
  return http.Axios({
    url: "/web/clientsCompany/treeByOrgId",
    method: "get"
  });
}
